import { WizardContext } from "../types/WizardContext";

export const ComputeGroupAverage = {
	name: "ComputeGroupAverage",
	description:"Computes the average of all numerical data channels with the same group ID.",
	parameters: {
		group: {
			type:"string",
			drawer(context:WizardContext){
				return {
					type:"dropdown",
					options:getGroupOptions(context.channels)
				}
			},
			default:null
		}
	},
	output:{
		name:{
			type:"string",
		},
		values:{
			type:"number[]",
		},
		labels:{
			type:"string[]",
		}
	}
};

const canAverageChannel = (c:any) => {
	if(c.value !== "number"){ return false; }
	return [
		"form/linearscale/row",
		"gallery/feedback/scale",
	].findIndex(t => t === c.type) > -1;
};


const getGroupOptions = (channels:any[]) => {
	const supported = channels.filter(canAverageChannel);
	const groups:any[] = [];
	supported.forEach(channel => {

		if(groups.findIndex(g => g.value === channel.group) > -1){
			return;
		}
		groups.push({
			value:channel.group,
			text:channel.groupName
		});
	});
	return groups;
};